export const mobileTypography = {
    labelXs: {
        fontSize: 'clamp(11px, 2.8vw, 12px)',
        lineHeight: 1.3,
        fontWeight: 400,
    },
    labelSm: {
        fontSize: 'clamp(12px, 3vw, 13px)',
        lineHeight: 1.35,
        fontWeight: 500,
    },
    bodySm: {
        fontSize: 'clamp(12px, 3.1vw, 14px)',
        lineHeight: 1.4,
        fontWeight: 400,
    },
    bodyMd: {
        fontSize: 'clamp(13px, 3.3vw, 15px)',
        lineHeight: 1.45,
        fontWeight: 400,
    },
    titleSm: {
        fontSize: 'clamp(15px, 3.8vw, 17px)',
        lineHeight: 1.35,
        fontWeight: 600,
    },
    titleMd: {
        fontSize: 'clamp(16px, 4.2vw, 19px)',
        lineHeight: 1.3,
        fontWeight: 700,
    },
};
